// extracted by mini-css-extract-plugin
export var acitonButtons = "_cx-0";
export var additionalIcon = "_cx-f";
export var block = "_cx-1";
export var blockContent = "_cx-7";
export var blockDescription = "_cx-8";
export var blockIcon = "_cx-9";
export var blockTitle = "_cx-6";
export var border = "_cx-a";
export var center = "_cx-l";
export var edge = "_cx-b";
export var edgeLabel = "_cx-c";
export var edgePath = "_cx-d";
export var error = "_cx-e";
export var flowchart = "_cx-g";
export var flowchartContent = "_cx-h";
export var highlighted = "_cx-3";
export var hover = "_cx-4";
export var icon = "_cx-i";
export var left = "_cx-m";
export var navButton = "_cx-j";
export var navButtons = "_cx-k";
export var right = "_cx-n";
export var selected = "_cx-2";
export var small = "_cx-5";